import { Component, OnInit} from "@angular/core";
import {FormBuilder,FormGroup,FormArray} from "@angular/forms";
import { ValidateCustomerService } from "./validateCustomer.service";
import { BaseCRUDComponent } from "../../Core/Abstract/baseCRUD.component";
import { LogService } from "../../Core/Abstract/log.service";
import { VisualsService } from "../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { SecurityService } from '../../Core/Security/security.service';
import { forkJoin } from "rxjs";
import { Subscription } from 'rxjs';
import { ConfigService } from '../../Core/Abstract/config.service';

@Component({
  selector: "validateCustomer-grid",
  templateUrl: "./validateCustomer.component.html",
  providers: [ValidateCustomerService]
})    
export class ValidateCustomerComponent extends BaseCRUDComponent<ValidateCustomerService>implements OnInit {
  form :any;
  options: FormlyFormOptions = {};
  model;
  ob:any;
  termsTemplate:any;
  clusterTerms:any;
  subscription: Subscription;
  subscriptionSubmit: Subscription;
  fields: FormlyFieldConfig[];
  userId: any;
  crsId: any;
  isOrigin: any;
  hasBackGround: any;
  loading: boolean = false;
  buyerCompanyInfo:any;
  
  constructor(
    private securityService: SecurityService,
    private service: ValidateCustomerService,
    private configService:ConfigService,
    fb: FormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router
  ) {
    super(logger, visualsService, route, fb, router);
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.crsId = this.route.snapshot.queryParamMap.get('crsId');
    this.ob = this.route.snapshot.queryParamMap.get('ob');
    this.isOrigin = this.route.snapshot.queryParamMap.get('isOrigin');
    this.getFormConfigAndData()
  }
  getFormConfigAndData(){
     
    this.loading = true;
    this.subscription = forkJoin(this.service.getFields(this.userId), this.service.loadBean(this.userId),this.visualsService.getParam('WELCOME_SCREEN_BACKGROUND')).subscribe(
        response =>{ 
          this.fields = JSON.parse(response[0].data.valForm);
          this.form = new FormArray(this.fields.map(() => new FormGroup({})));
          this.hasBackGround = response[2].paramValStr; 
          if(this.hasBackGround == 'Y'){
            let url = '/assets/images/logo/'+this.configService.getClient()+'/welcome-screen.png';
            document.querySelector("body").style.backgroundImage = "url("+url+")";
            document.querySelector("body").style.backgroundSize = "cover";
            document.querySelector("body").style.backgroundPosition = "center";
            document.querySelector("body").style.backgroundRepeat = "no-repeat";
          }
          this.loading = false
        },
        error => console.log("Error: ", error),
        () =>{
          
        }
    )
  }
  
    submit(){
      if (!this.form.valid) {
        return
      }
      let formToSend = this.form.value
      this.loading = true;
      this.subscriptionSubmit = forkJoin(this.service.validate(formToSend,this.userId,this.crsId),this.service.save(formToSend,this.userId)).subscribe(
          response =>{ 
            this.securityService.router.navigate(['/menu/onboard'], {queryParams: {userId: this.userId,isOrigin:this.isOrigin}});
              LogService.emitAlert({
                type: "success",
                body: this.genericVisuals.dataSaved
            });
            this.loading = false;
          },
          error => {
            this.loading = false;
            console.log("Error: ", error)
            LogService.emitAlert({
              type: "error",
              body: this.genericVisuals[error.error.message]
          });
          },
          () =>{
            this.loading = false;
          }
      )

    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
  }
